<template>
  <div class="point-page">
    <el-collapse class="home-msg_collapse" v-model="activeNames">
      <el-collapse-item :name="curName">
        <template slot="title">
          <div class="spaceBetween home-msg_collapse_head">
            <div>
              <svg-icon icon-class="tn-down" class="icon-arrow" />
              <span>Well {{ wellIndex + 1 }}</span>
            </div>
            <span v-if="!removeDisabled">
              <el-popover placement="top" width="300" trigger="hover">
                <p class="spaceLeft popover-confirm"><i class="el-icon-warning" />Are you sure you want to delete ?</p>
                <div class="page-btns" style="text-align: right; margin: 0">
                  <el-button size="mini">Cancel</el-button>
                  <el-button type="primary" size="mini" @click="deleteWell">Sure</el-button>
                </div>
                <span slot="reference" class="time-text">
                  <svg-icon icon-class="tn-delete" />
                  Delete
                </span>
              </el-popover>
            </span>
          </div>
        </template>
        <div>
          <el-form class="page-form point-form" ref="addWellForm" :model="pageData" :rules="pageRules"
            label-position="top">
            <el-row :gutter="40">
              <el-col :span="12">
                <el-form-item prop="nickname" label="Well Name">
                  <el-input v-model="pageData.nickname" type="text" auto-complete="off" placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24"></el-col>
              <el-col :span="12">
                <el-form-item prop="location_id" label="location_id">
                  <el-input v-model="pageData.location_id" type="text" auto-complete="off" placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="location" label="location">
                  <el-input v-model="pageData.location" type="text" auto-complete="off" placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="aerLicensee" label="AER Licensee">
                  <el-input v-model="pageData.aerLicensee" type="text" auto-complete="off" placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="aerLicenseNo" label="AER License No">
                  <el-input v-model="pageData.aerLicenseNo" type="text" auto-complete="off" placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="aerSurfaceLocation" label="AER surface location">
                  <el-input v-model="pageData.aerSurfaceLocation" type="text" auto-complete="off"
                    placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="UWI" label="AER UWI">
                  <el-input v-model="pageData.UWI" type="text" auto-complete="off" placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item prop="APIGravity" label="API Gravity">
                  <el-input v-model="pageData.APIGravity" type="text" auto-complete="off" placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="sulphur" label="Sulphur Content">
                  <el-input v-model="pageData.sulphur" type="text" auto-complete="off" placeholder="Please fill in">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="fromToIDIdentifier" label="FromToIDIdentifier">
                  <el-input v-model="pageData.fromToIDIdentifier" type="text" auto-complete="off"
                    placeholder="Please fill in">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="oilAnalysis" label="OIL ANALYSIS">
                  <file-upload
                    :defaultFileList="pageData.oilAnalysis ? [{ name: pageData.oilAnalysis, uid: pageData.oilAnalysis }] : undefined"
                    @onSuccess="handleFileSuccess($event, 'oilAnalysis')"
                    @onRemove="handleFileRemove($event, 'oilAnalysis')" />
                </el-form-item>
              </el-col>
              <el-col :span="24"></el-col>
              <el-col :span="12">
                <el-form-item prop="wellLisence" label="WELL LISENCE">
                  <file-upload :defaultFileList="pageData.wellLisence
                      ? [{ name: pageData.wellLisence, uid: pageData.wellLisence }]
                      : undefined
                    " @onSuccess="handleFileSuccess($event, 'wellLisence')"
                    @onRemove="handleFileRemove($event, 'wellLisence')" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { updateWell, checkWell } from "@/api/producer.js"
import { addWell } from "@/api/well.js"
export default {
  props: {
    wellIndex: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    removeDisabled: {
      type: Boolean
    },
    defaultPageData: {
      type: Object,
      default: () => {
        return {

          location: undefined,
          location_id: undefined,
          aerLicenseNo: undefined,
          aerLicensee: undefined,
          aerSurfaceLocation: undefined,
          fromToIDIdentifier: undefined,
          UWI: undefined,
          sulphur: undefined,
          APIGravity: undefined,
          oilAnalysis: undefined,
          wellLisence: undefined,

        }
      }
    }
  },
  components: {
  },
  data() {
    return {
      curName: "wellName_" + new Date().getTime(),
      pageData: this.defaultPageData,
      pageRules: {
        nickname: [
          {
            required: true,
            trigger: "blur",
            message: "Well Name cannot be empty"
          },
          { min: 1, max: 50, message: 'Within 50 characters', trigger: 'blur' }
        ],
        location_id: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("Location_id of Measurement Point cannot be empty"));
              }
              // else if (!this.dict.reg.number.value.test(value)) {
              //   return callback(new Error(this.dict.reg.number.desc));
              // }
              else {
                callback();
              }
            },
          },
          { min: 1, max: 30, message: 'Within 30 characters', trigger: 'blur' }
        ],
        location: [
          {
            required: true,
            trigger: "blur",
            message: "location of Measurement  cannot be empty"
          },
          { min: 1, max: 50, message: 'Within 50 characters', trigger: 'blur' }
        ],
        aerLicenseNo: [
          {
            required: true,
            trigger: "blur",
            message: "AER License No cannot be empty"
          },
          { min: 1, max: 30, message: 'Within 30 characters', trigger: 'blur' }
        ],
        aerLicensee: [
          {
            required: true,
            trigger: "blur",
            message: "AER License cannot be empty"
          },
          { min: 1, max: 30, message: 'Within 30 characters', trigger: 'blur' }
        ],
        aerSurfaceLocation: [
          {
            required: true,
            trigger: "blur",
            message: "AER surface location cannot be empty"
          },
          { min: 1, max: 30, message: 'Within 30 characters', trigger: 'blur' }
        ],
        fromToIDIdentifier: [
          {
            required: true,
            trigger: "blur",
            message: "FromToIDIdentifier cannot be empty"
          },
          { min: 1, max: 30, message: 'Within 30 characters', trigger: 'blur' }
        ],
        UWI: [
          {
            required: true,
            trigger: "blur",
            message: "AER UWI cannot be empty",
          },
          { min: 1, max: 20, message: 'Within 20 characters', trigger: 'blur' }
        ],
        sulphur: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("Sulphur Content cannot be empty"));
              }
              else if (value > 100) {
                return callback(new Error(this.dict.reg.sulphur.desc));
              }
              else if (!this.dict.reg.sulphur.value.test(value)) {
                return callback(new Error(this.dict.reg.sulphur.desc));
              }
              else {
                callback();
              }
            }
          },

        ],
        APIGravity: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error("API Gravity Content cannot be empty"));
              }
              else if (value > 100) {
                return callback(new Error(this.dict.reg.APIGravity.desc));
              }
              else if (!this.dict.reg.APIGravity.value.test(value)) {
                return callback(new Error(this.dict.reg.APIGravity.desc));
              } else {
                callback();
              }
            }
          }
        ],
        oilAnalysis: [
          {
            required: true,
            trigger: "blur",
            message: "OIL ANALYSIS Content cannot be empty"
          }
        ],
        wellLisence: [
          {
            required: true,
            trigger: "blur",
            message: "WELL LISENCE Content cannot be empty"
          }
        ],
      },
      oilContract: undefined,
      oilAddress: undefined,
      gasContract: undefined,
      gasAddress: undefined,
    };
  },
  computed: {
    activeNames() {
      return [this.curName];
    }
  },
  methods: {
    handleFileSuccess({ response, file, fileList }, item) {
      this.pageData[item] = response.result.fileName;
      this.$refs.addWellForm.validateField(item);
    },
    handleFileRemove(fileList, item) {
      this.pageData[item] = undefined;
      this.$refs.addWellForm.validateField(item);
    },
    deleteWell() {
      this.$emit("remove", this.wellIndex, this.pageData.wellID);
    },
    checkWellFun(well) {
      return new Promise((resolve, reject) => {
        delete well.title_id;
        delete well.title;
        checkWell(well).then(res => {
          if (res.result) {
            resolve();
          } else {
            reject("Well " + (this.wellIndex + 1) + " already exists! ");
          }
        }).catch(e => {
          reject(e);
        })
      })
    },
    check() {
      return new Promise((resolve, reject) => {
        let wellFlag = false;
        this.$refs.addWellForm.validate((valid) => { wellFlag = valid; });
        this.pageData.sulphur = Number(this.pageData.sulphur);
        this.pageData.APIGravity = Number(this.pageData.APIGravity);
        if (!wellFlag) {
          this.$message.error("Well " + (this.wellIndex + 1) + ": Please complete the required items");
          reject("Well " + (this.wellIndex + 1) + ": Please complete the required items");
          return;
        }
        this.checkWellFun(this.pageData).then(res => {
          resolve(res);
          return;
        }).catch(e => {
          reject(e);
          return;
        })
      })
    },
    submit() {
      const self = this;
      return new Promise((resolve, reject) => {
        if (this.pageData._id) {
          updateWell(this.pageData).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          })
        } else {
          addWell(this.pageData).then(res => {
            const uniqueId = web3.utils.padRight(web3.utils.toHex(res.result), 64);
            Promise.all([this.handleAddProducer('oil',uniqueId),this.handleAddProducer('gas',uniqueId)]) .then(res => {
              resolve(res);
            })
          }).catch(err => {
            reject(err);
          })
        }
      })
    },
    handleAddProducer(type,uniqueId) {
      return new Promise((resolve, reject) => {
        const contract = type === 'oil' ? this.oilContract : this.gasContract
        const address = type === 'oil' ? this.oilAddress : this.gasAddress
        const tx_builder = contract.methods["addProducer"](uniqueId, [
          this.pageData.nickname,
          this.$store.getters.metaMaskObj.account,
          Number(this.pageData.APIGravity) * 100,
          Number(this.pageData.sulphur) * 1000,
          ''
        ]);
        const encoded_tx = tx_builder.encodeABI();

        let json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: address,
          value: 0,
          data: encoded_tx,
        };
        web3.eth
          .sendTransaction(json)
          .then((res) => {
            resolve();
          })
          .catch((error) => {
            reject();
            this.$message.error("operation failed");
            console.error(error);
          });
      });
    },
  },
  created() {
    this.getAbi("OilProducer").then((res) => {
      this.oilContract = new web3.eth.Contract(res.data.abi, res.data.address);
      this.oilAddress = res.data.address;
    });
    this.getAbi("GasProducer").then((res) => {
      this.gasContract = new web3.eth.Contract(res.data.abi, res.data.address);
      this.gasAddress = res.data.address;
    });
  },
  mounted() { }
};
</script>
<style scoped lang="scss">
.point-page {
  border: 1px solid rgba(0, 0, 0, 0.1);

  .home-msg_collapse {
    border-top: none;
    border-left: none;
    border-right: none;

    ::v-deep .el-collapse-item__header {
      border-bottom: none;
      color: #000;
      font-weight: bold;
      font-size: 0.18rem;
      padding: 0.24rem 0.32rem;

      .icon-arrow {
        transform: rotate(-90deg);
      }

      &.is-active {
        .icon-arrow {
          color: #666;
          transform: rotate(0deg);
          display: inline-block;
        }
      }
    }

    ::v-deep .el-collapse-item__content {
      border-bottom: none;
      font-size: 0.18rem;
      color: #575757;
      padding: 0;
    }

    ::v-deep .el-collapse-item__wrap {
      border-bottom: none;
    }

    ::v-deep .el-collapse-item__arrow {
      display: none;
    }

    .home-msg_collapse_head {
      width: 100%;

      .time-text {
        color: #a3a3a3;
        font-weight: normal;
      }
    }

    .point-form {
      padding: 0 0.52rem;
    }
  }

  .add-btn-box {
    padding: 0.24rem 0.56rem;
    background: #fafafa;

    .add-btn {
      border-style: dashed;
      font-size: 0.18rem;
    }

    .width100 {
      width: 100%;
    }
  }
}
</style>
